import { PostMethod } from "../../../methods/PostMethod";
import { ICreateCommentResponse } from "../../common/response.types";

export class CreateCommentEndpoint extends PostMethod<ICreateCommentResponse> {
  constructor() {
    super(`${process.env.REACT_APP_API_URL}/checklists/groups/checks/comments`);
  }
}
